import { normalizeSet } from "@/features/table-filters/contract/definitions";
import {
  canonicalFilterKey,
  serializeFilterRequest,
} from "@/features/table-filters/contract/state";

export interface CalendarLocationFilterRequest {
  locationIds?: string[];
  includeUnassigned?: boolean;
}

export const CALENDAR_INCLUDE_UNASSIGNED_WHEN_LOCATION_FILTERED = true;

export function canonicalCalendarLocationFilter({
  locationIds,
  includeUnassigned,
}: CalendarLocationFilterRequest): CalendarLocationFilterRequest {
  const normalizedLocationIds = normalizeSet(locationIds);

  return canonicalFilterKey({
    ...(normalizedLocationIds ? { locationIds: normalizedLocationIds } : {}),
    ...(includeUnassigned ? { includeUnassigned: true } : {}),
  });
}

export function calendarSelectedLocationFilter(
  locationIds: readonly string[],
): CalendarLocationFilterRequest {
  return canonicalCalendarLocationFilter({
    locationIds: [...locationIds],
    includeUnassigned:
      locationIds.length > 0
        ? CALENDAR_INCLUDE_UNASSIGNED_WHEN_LOCATION_FILTERED
        : undefined,
  });
}

export function serializeCalendarGetParams(
  params: Record<string, unknown>,
  locationFilter: CalendarLocationFilterRequest = {},
): URLSearchParams {
  return serializeFilterRequest({
    ...params,
    ...canonicalCalendarLocationFilter(locationFilter),
  });
}
